<template>
  <div class="page main-background">
    <div class="sub-header">
      <h2>دریافت استعلام وضعیت گواهینامه</h2>
    </div>
    <div class="custom-box mar40t">
      <div class="custom-box-text" style="padding-top: 30px;">
        برای استعلام وضعیت گواهینامه کافی است، کد ملی و تلفن همراه خود را در فرم
        زیر وارد نماید. با پرداخت 5200 تومان به عنوان هزینه استعلام، اعتبار و
        وضعیت گواهینامه تازه یا المثنی خود را پیگیری کنید.
      </div>
      <div>
        <span class="icon-box">
          <i class="far fa-car"></i>
        </span>
      </div>
      <div>
        <input
          type="text"
          class="input"
          v-model="NationalityCodeInput"
          placeholder="کد ملی دارنده گواهینامه"
          maxlength="10"
          @keypress="isNumber($event)"
        />
        <input
          type="text"
          class="input"
          v-model="MobileInput"
          placeholder="تلفن همراه دارنده گواهینامه"
          maxlength="11"
          @keypress="isNumber($event)"
        />
        <input
          v-if="this.CodeFlag"
          type="text"
          class="input"
          v-model="Code"
          placeholder="کد ارسال شده به تلفن همراه"
          maxlength="5"
          @keypress="isNumber($event)"
        />
        <span
          v-if="this.NationalityCodeActive == true && this.MobileActive == true"
        >
          <span v-if="this.userMobile == this.MobileInput">
            <a class="input primary-btn" @click="getInquiry">استعلام</a>
          </span>
          <span v-else-if="this.userMobile != this.MobileInput && !this.Code">
            <a class="input primary-btn" @click="sendOtp">استعلام</a>
          </span>
          <span v-else-if="this.userMobile != this.MobileInput && this.Code">
            <a class="input primary-btn" @click="getInquiry">استعلام</a>
          </span>
        </span>
        <span v-else>
          <div class="input primary-btn deactive">استعلام</div>
        </span>
      </div>
    </div>
    <div v-if="!loading">
      <div v-if="errorMessage">
        <div
          class="error-message"
          v-if="errorMessage"
          style="text-align: center; margin: 0 10px 0"
        >
          <h3 class="loading-title text-color">
            {{ errorMessage }}
          </h3>
        </div>
      </div>
      <div v-if="!errorMessage && this.LicenseNegativePoint">
        <h2 class="page-title text-color">
          نتیجه استعلام وضعیت گواهینامه
        </h2>
        <div v-for="item in this.LicenseNegativePoint" :key="item.id">
          <div class="fines text-color border-color background-color">
            <table>
              <tr>
                <td class="fines-header first">نام</td>
                <td class="fines-header">وضعیت</td>
                <td class="fines-header last">نوع</td>
              </tr>
              <tr>
                <td>{{ item.firstName }} {{ item.lastName }}</td>
                <td>{{ item.rahvarStatus }}</td>
                <td>{{ item.title }}</td>
              </tr>
              <tr>
                <td class="secondary-title first">تاریخ صدور</td>
                <td class="secondary-title">مدت اعتبار</td>
                <td class="secondary-title last">شماره گواهینامه</td>
              </tr>
              <tr>
                <td>{{ item.printDate | persian }}</td>
                <td>{{ item.validYears | persian }} سال</td>
                <td>{{ item.printNum | persian }}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <div v-if="!errorMessage && this.LicenseNegativePoint == ''">
        <div
          class="success-message"
          style="text-align: center; margin: 10px 10px 0"
        >
          شما فاقد گواهینامه می باشید.
        </div>
      </div>
    </div>
    <div v-if="loading">
      <h3 class="loading-title text-color loading-box">
        در حال دریافت استعلام وضعیت گواهینامه، لطفا شکیبا باشید.
      </h3>
      <loader />
    </div>
  </div>
</template>

<script>
import api, { BaseUrl_New } from "../../service";
import loader from "../../components/inquiry/Loader";
import { mapGetters } from "vuex";

export default {
  name: "license-status-inquiry",
  components: {
    loader,
  },
  computed: {
    ...mapGetters(["getToken"]),
  },
  data() {
    return {
      errorMessage: null,
      loading: false,
      LicenseNegativePoint: null,
      NationalityCodeInput: "",
      MobileInput: "",
      Code: "",
      baseUrl: BaseUrl_New,
      client: 3,
      NationalityCodeActive: false,
      MobileActive: false,
      CodeFlag: false,
      userMobile: "",
    };
  },
  methods: {
    isNumber: function(e) {
      var iKeyCode = e.which ? e.which : e.keyCode;
      if (iKeyCode != 46 && iKeyCode > 31 && (iKeyCode < 48 || iKeyCode > 57))
        e.preventDefault();
      return true;
    },
    sendOtp() {
      this.CodeFlag = true;
      api
        .getSendOtp(this.MobileInput)
        .then((response) => {
          if (response.data && response.data.status === 200) {
            this.errorMessage = response.data.messages[0];
          } else {
            if (
              response.data &&
              response.data.messages &&
              response.data.messages.length > 0
            ) {
              this.errorMessage = response.data.messages[0];
            }
          }
        })
        .catch((err) => {
          this.errorMessage =
            "لطفا دسترسی اینترنت خود را چک کرده و دوباره امتحان کنید.";
          this.errorMessage = err.response.data.messages[0];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getInquiry() {
      this.errorMessage = "";
      api
        .getLicenseStatusInquiryByInfo(
          this.client,
          this.Code,
          this.MobileInput,
          this.NationalityCodeInput
        )
        .then((response) => {
          if (
            response.data &&
            response.status === 200 &&
            response.data.status === 200
          ) {
            this.LicenseNegativePoint = response.data.data;
          } else {
            if (
              response.data &&
              response.data.messages &&
              response.data.messages.length > 0
            ) {
              this.errorMessage = response.data.messages[0];
            }
          }
        })
        .catch((err) => {
          this.errorMessage =
            "لطفا دسترسی اینترنت خود را چک کرده و دوباره امتحان کنید.";
          this.errorMessage = err.response.data.messages[0];
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    //this.loading = true;
    // this.LicenseNegativePoint = [
    //   {
    //     nationalNo: '0079358934',
    //     firstName: 'سمانه',
    //     lastName: 'صفر آبادي فراهاني',
    //     title: 'پايه سوم',
    //     rahvarStatus: 'اسکن شده ناجي پاس',
    //     barcode: '18594000017002897328',
    //     printDate: '1393/05/16',
    //     printNum: '9382388194',
    //     validYears: '10',
    //   },
    // ]
    //this.LicenseNegativePoint = []
    // api
    //   .getLicenseStatusInquiry(this.client)
    //   .then((response) => {
    //     if (response.data && response.data.status === 200) {
    //       this.LicenseNegativePoint = response.data.data;
    //     } else {
    //       if (
    //         response.data &&
    //         response.data.messages &&
    //         response.data.messages.length > 0
    //       ) {
    //         this.errorMessage = response.data.messages[0];
    //       }
    //     }
    //   })
    //   .catch(() => {
    //     this.errorMessage =
    //       "متاسفانه خطای فنی رخ داده است؛ لطفا دوباره امتحان کنید.";
    //   })
    //   .finally(() => {
    //     this.loading = false;
    //   });
    api
      .getUserInformation()
      .then((response) => {
        if (response.data && response.data.status === 200) {
          this.userMobile = response.data.data.mobile;
          //console.log(response.data.data);
        } else {
          if (
            response.data &&
            response.data.Messages &&
            response.data.Messages.length > 0
          ) {
            this.errorMessage = response.data.Messages[0];
          }
        }
      })
      .catch(() => {
        this.errorMessage =
          "متاسفانه خطای فنی رخ داده است؛ لطفا دوباره امتحان کنید.";
      })
      .finally(() => {
        this.loading = false;
      });
  },
  watch: {
    MobileInput(item) {
      if (item) {
        this.MobileActive = true;
      } else {
        this.MobileActive = false;
      }
    },
    NationalityCodeInput(item) {
      if (item) {
        this.NationalityCodeActive = true;
      } else {
        this.NationalityCodeActive = false;
      }
    },
  },
};
</script>

<style scoped></style>
